import '../../lightgallery/scss/lightgallery.scss';
import '../../lightgallery/scss/lg-thumbnail.scss';
import '../../lightgallery/scss/lg-autoplay.scss';
import '../../lightgallery/scss/lg-share.scss';

import {LightGallerySettings} from '../../lightgallery/lg-settings';
import {LightGallery} from "../../lightgallery/lightgallery";
import Thumbnail from '../../lightgallery/plugins/thumbnail/lg-thumbnail';
import Autoplay from '../../lightgallery/plugins/autoplay/lg-autoplay';
import Share from '../../lightgallery/plugins/share/lg-share';

interface CustomEventMap {
    "openGallery": CustomEvent<any>;
}

declare global {
    interface Window {
        openGallery: (items: [], active: boolean) => void;
    }

    interface Document { //adds definition to Document, but you can do the same with HTMLElement
        addEventListener<K extends keyof CustomEventMap>(type: K,
           listener: (this: Document, ev: CustomEventMap[K]) => void): void;
        dispatchEvent<K extends keyof CustomEventMap>(ev: CustomEventMap[K]): void;
    }
}

export function applyTo(selector: string, options?: LightGallerySettings) {
    if (window.openGallery === undefined) {
        window.openGallery = function (items, active) {
            document.dispatchEvent(new CustomEvent(
                'openGallery', {
                    detail: {
                        items: items,
                        active: active,
                    }
                }
            ));
        };

        document.addEventListener('openGallery', (e) => {
            console.log(e.detail);
            const div = document.createElement('div');
            (new LightGallery(div, {
                dynamic: true,
                dynamicEl: e.detail.items,
                plugins: [Thumbnail, Autoplay, Share],
            })).openGallery(e.detail.active);
        });
    }

    document.querySelectorAll(selector).forEach(function(element) {
        if(options) {
            options.plugins = [Thumbnail, Autoplay, Share];
        }

        let lightgallery = new LightGallery(element as HTMLElement, options);
    });
}

